import styled from "styled-components";

import { FlexColumn, FlexRow } from "../Styles";

export const Container = styled(FlexRow)<{
  $width: number;
  $backgroundColor: string;
  $isSingleAuthor: boolean;
}>`
  padding: ${({ theme }) => theme.spacing["spacing-3"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-s"].value}rem;
  background: ${({ $backgroundColor, theme }) =>
    $backgroundColor
      ? $backgroundColor
      : theme.Color.elevation.surface["surface-primary"].value};
  box-shadow: 1px 1px 20px 0px #010d16;
  align-items: center;
  justify-content: flex-end;
  flex-direction: ${({ $isSingleAuthor }) =>
    $isSingleAuthor ? "column" : "row"};
  transition: all 0.3s ease-out;
  width: ${({ $width, $isSingleAuthor }) =>
    $isSingleAuthor ? "fit-content" : `${$width}px`};
  overflow: hidden;
  backdrop-filter: blur(4px);
`;

export const Wrapper = styled(FlexColumn)<{ $isSingleAuthor: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: ${({ $isSingleAuthor }) =>
    $isSingleAuthor ? "center" : "flex-start"};
`;

export const AvatarGroupContainer = styled.div<{
  $selectedAvatar: number;
  $isCollapsed: boolean;
}>`
  & > div > div {
    opacity: ${({ $isCollapsed }) => ($isCollapsed ? 1 : 0.2)};
  }
  & > div > div:nth-child(${({ $selectedAvatar }) => $selectedAvatar}) {
    opacity: 1;
  }
`;
